import React from "react";
import { Heading } from "../../atoms/Heading/Heading";
import { Skeleton } from "../../atoms/Skeleton/Skeleton";
import { Text } from "../../atoms/Text/Text";
import { cn } from "../../lib/cn";
import { tabularNumsClass } from "../../tokens/typography";

interface StatCardProps {
  label: string;
  value: string;
  hint?: string;
  // Swaps value for a skeleton sized to size="lg"'s line-height (36px, h-9) —
  // same footprint, no reflow when the real value arrives. hint is omitted
  // while loading since its presence can't be known ahead of the fetch.
  loading?: boolean;
  className?: string;
}

export function StatCard({ label, value, hint, loading = false, className = "" }: StatCardProps) {
  return (
    <div className={cn("rounded-md border border-border bg-surface-raised p-6 shadow-sm", className)}>
      <Text as="p" size="sm" variant="muted">
        {label}
      </Text>
      {loading ? (
        <Skeleton variant="text" className="mt-1 h-9 w-28" />
      ) : (
        <Heading as="p" size="lg" className={cn("mt-1", tabularNumsClass)}>
          {value}
        </Heading>
      )}
      {!loading && hint && (
        <Text as="p" size="xs" variant="muted" className="mt-1">
          {hint}
        </Text>
      )}
    </div>
  );
}
